import React from 'react';

import { useTranslation } from 'react-i18next';

import { Tourist } from '../../../types';
import { Text18 } from '../../../ui/Text18';
import { TouristDataWrapper, Row, Bold, ClientResponsability } from '../index.style';
import { iSoToDate } from '../../../helpers/fromIsoToDate';

const TouristData: React.FC<{ tourist: Tourist; index: number }> = ({
  tourist,
  index,
}) => {
  const { t } = useTranslation();
  const { name, surname, birthDate, passportNumber, idnp, phoneNumber, email, country } =
    tourist || {};
  const touristDate = iSoToDate(birthDate).toLocaleDateString();
 
  return (
    <TouristDataWrapper>
      <Row>
        <Text18>{`${t('tourist')} ${index + 1}`}</Text18>
        <Text18>
          <Bold>{` ${name} ${surname}`}</Bold>
        </Text18>
      </Row>

      <Row>
        <Text18>
          <Bold>{touristDate}</Bold>
        </Text18>
        <Text18>
          <Bold>{passportNumber}</Bold>
        </Text18>
        <Text18>
          <Bold>{idnp}</Bold>
        </Text18>
      </Row>

      <Row>
        <Text18>
          <Bold>{phoneNumber}</Bold>
        </Text18>
        <Text18>
          <Bold>{email}</Bold>
        </Text18>
        <Text18>
          <Bold>{country}</Bold>
        </Text18>
      </Row>
      <Row>
        <ClientResponsability>
          *{t('client_responsability')}
        </ClientResponsability>
      </Row>
    </TouristDataWrapper>
  );
};

export default TouristData;
